import React from 'react';
import '../less/faq.less';
import Qna from '../views/qna';

export default function template() {
    const answer = !this.state.isOn ? (
        ''
    ) : (
        <div className="answer">
            <div
                className={`answer-text ${this.props.data.answer ? '' : 'empty'}`}
                dangerouslySetInnerHTML={{__html: this.props.data.answer}}
            />
            {!this.props.data.children ? (
                ''
            ) : (
                <div className="subquestion">
                    {this.props.data.children.map((item, index) => (
                        <Qna data={item} key={index} />
                    ))}
                </div>
            )}
        </div>
    );

    return (
        <div className="question">
            <div
                className={`question-header ${this.state.isOn ? 'active' : ''}`}
                onClick={this.toggleAnswer}
            >
                <div className="question-text">{this.props.data.question}</div>
                <div className="arrow" />
            </div>
            {answer}
        </div>
    );
}
